import { create } from 'zustand';
import { api } from '../api/client';
import type { Token, User } from '../api/types';

interface AppState {
  user: User | null;
  ready: boolean;
  /** Сквозной фильтр по токену: применяется к дашборду, потокам и логам. */
  tokenFilter: string;
  tokens: Token[];
  init: () => Promise<void>;
  login: (login: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  setTokenFilter: (id: string) => void;
  refreshTokens: () => Promise<void>;
}

export const useApp = create<AppState>((set, get) => ({
  user: null,
  ready: false,
  tokenFilter: '',
  tokens: [],

  init: async () => {
    try {
      const user = await api.me();
      set({ user });
      await get().refreshTokens();
    } catch {
      set({ user: null });
    } finally {
      set({ ready: true });
    }
  },

  login: async (login, password) => {
    const user = await api.login(login, password);
    set({ user });
    await get().refreshTokens();
  },

  logout: async () => {
    await api.logout();
    set({ user: null, tokens: [], tokenFilter: '' });
  },

  setTokenFilter: (id) => set({ tokenFilter: id }),

  refreshTokens: async () => {
    try {
      const { items } = await api.tokens();
      set({ tokens: items });
    } catch {
      set({ tokens: [] });
    }
  },
}));
